export default "__VITE_ASSET__2709063e__"